module.exports = __webpack_public_path__ + "img/Dodge_logo_300x300.10c851ac.png";